import { Button, Row, Typography } from 'antd';
import type { Dispatch, SetStateAction } from 'react';
import { Link } from 'react-router';

import { MenuUnfoldOutlined } from '@ant-design/icons';

import { AppCode, RoleLabel } from '../../enum';
import {
  appCode,
  appName,
  isBQDomain,
  validateAsAdmin,
  validateAsFirstAlertsRole,
  validateAsSPManagerRole,
} from '../../helpers/utils.helper';
import { useAppSelector } from '../../hooks';
import type { AuthResult, CurrentUser } from '../pages/Login/authSlice';
import SideNavMenu from './sidemenu';

const getText = (currentUser: CurrentUser, authResult: AuthResult) => {
  if (validateAsAdmin(currentUser.role)) {
    return RoleLabel[currentUser.role];
  } else if (validateAsSPManagerRole(currentUser.role)) {
    return authResult.service_provider_organization_name;
  } else {
    return authResult.org_name;
  }
};

const getImg = (currentUser: CurrentUser, collapsed: boolean) => {
  if (validateAsFirstAlertsRole(currentUser.role)) {
    return `/assets/first-alerts-${collapsed ? 'icon' : 'logo'}.svg`;
  }
  if (validateAsAdmin(currentUser.role)) {
    return `/assets/trycycle-${collapsed ? 'icon' : 'logo'}.png`;
  }
  if (currentUser.app_code === AppCode.BuddysQuest) {
    return `/assets/bq-logo-${collapsed ? 'sm' : 'md'}.png`;
  }
  // Default to TS logos
  if (collapsed) {
    return '/assets/ts-logo-sm.png';
  } else {
    return '/assets/talkingstick_logo_full_1200.png';
  }
};

const SideNav = ({
  collapsed,
  setCollapsed,
}: {
  collapsed: boolean;
  setCollapsed: Dispatch<SetStateAction<boolean>>;
}) => {
  const authResult = useAppSelector((state) => state.authSlice.authResult);
  const currentUser = useAppSelector((state) => state.authSlice.currentUser);
  const isFirstAlerts = validateAsFirstAlertsRole(currentUser.role);
  const isAdmin = validateAsAdmin(currentUser.role);

  return (
    <>
      <Row align="middle" justify="start" wrap={false} style={{ height: 60 }}>
        <Button className="sideMenuBtn" onClick={() => setCollapsed(!collapsed)}>
          <MenuUnfoldOutlined />
        </Button>
        {!collapsed ? (
          <Typography.Text className="side-bar-text-animated" strong>
            {getText(currentUser, authResult)}
          </Typography.Text>
        ) : null}
      </Row>
      <Row align="middle" justify="center" style={{ height: 60 }}>
        <Link to="/">
          <img
            src={getImg(currentUser, collapsed)}
            alt={`${isFirstAlerts ? 'FirstAlerts' : appCode !== null ? appName(appCode) : 'TryCycle Data Systems'} logo`}
            style={{ height: isAdmin ? 36 : !collapsed && isBQDomain ? 72 : 36 }}
          />
        </Link>
      </Row>
      <SideNavMenu />
    </>
  );
};

export default SideNav;
